// extracted by mini-css-extract-plugin
export default {"row":"createMatches_row__DcQs5","col":"createMatches_col__CLGoa","card":"createMatches_card__JoDLO"};